export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-teal-600 via-purple-600 to-rose-600 text-white py-10">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Brand */}
            <div className="md:col-span-1">
              <h3 className="text-xl font-bold mb-3">L.J. Boydston</h3>
              <p className="text-sm text-white/80 leading-relaxed">
                Creating magical stories that inspire young minds and spark imagination ✨
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-base font-bold mb-3 flex items-center gap-2">
                <i className="ri-links-line"></i>
                Quick Links
              </h4>
              <ul className="space-y-2">
                <li>
                  <a href="#books" className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">
                    <i className="ri-book-2-line text-xs"></i>
                    Books
                  </a>
                </li>
                <li>
                  <a href="#author" className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">
                    <i className="ri-user-heart-line text-xs"></i>
                    About Author
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer">
                    <i className="ri-mail-line text-xs"></i>
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Books */}
            <div>
              <h4 className="text-base font-bold mb-3 flex items-center gap-2">
                <i className="ri-book-open-line"></i>
                Featured Books
              </h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://www.amazon.com/March-Ants-Garden-Patch-Kids/dp/B0DNKZ7YQD"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    March of the Ants
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.amazon.com/What-that-Smell-L-Boydston-ebook/dp/B0GF8VX18K"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-xs"></i>
                    What Is that Smell?
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.amazon.com/stores/L-J-Boydston/author/B0GFBQXQXQ"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-white/80 hover:text-white transition-colors flex items-center gap-1 cursor-pointer"
                  >
                    <i className="ri-store-line text-xs"></i>
                    View All Books
                  </a>
                </li>
              </ul>
            </div>

            {/* Connect */}
            <div>
              <h4 className="text-base font-bold mb-3 flex items-center gap-2">
                <i className="ri-heart-line"></i>
                Connect
              </h4>
              <p className="text-sm text-white/80 mb-3">
                Stay updated with new releases and author news!
              </p>
              <div className="flex gap-3">
                <a
                  href="https://www.amazon.com/stores/L-J-Boydston/author/B0GFBQXQXQ"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-9 h-9 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 transform hover:scale-110 cursor-pointer"
                  aria-label="Amazon"
                >
                  <i className="ri-amazon-line text-lg"></i>
                </a>
                <a
                  href="#contact"
                  className="w-9 h-9 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/30 transition-all duration-300 transform hover:scale-110 cursor-pointer"
                  aria-label="Email"
                >
                  <i className="ri-mail-line text-lg"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-white/20 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-white/80 text-center md:text-left">
              © {currentYear} L.J. Boydston. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
